export class CasePage {
  init(): void {
    // 導入事例一覧ページ
  }
}
